/*
 * @Author: dongbo 254126189@qq.com
 * @Date: 2023-12-19 19:50:10
 * @LastEditors: dongbo 254126189@qq.com
 * @LastEditTime: 2025-08-11 14:07:56
 * @FilePath: /hippo-app-h5/hippo-app-h5/src/main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AEcxvbn
 */
import { createApp } from 'vue'
import type { App } from 'vue'
import type { Emitter, EventType } from 'mitt'
import type { Bridge } from '@gwm/bridge'
import 'uno.css'
import '@gwm-ui/h5/lib/index.css'
import 'vant/es/dialog/style'
import 'vant/es/toast/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'
import mitt from 'mitt'
import GwmBridge from '@/utils/bridge'
import Filter from '@/utils/filter'
//import SensorsData from '@/utils/sensors'
// import Sentry from '@/utils/sentry';
// import * as SentryVue from '@sentry/vue';
import Router from '@/router'
import Store from '@/store'
import Main from './App.vue'
import Directive from './directive'
import { Lazyload } from 'vant'
import defLoadingImg from '@/assets/loading/loading-w670.png'
import Cookies from 'js-cookie'
import QT from '@/utils/QT'
import { bridge } from './utils/bridge/index'

console.log('当前页面地址：', window.location.href)

try {
  let userInfo = bridge.userInfo() || null
  if (userInfo) {
    __bl.setConfig({
      uid: userInfo.userId,
    })
    __bl.setConfig({
      setUsername: function () {
        return userInfo.userId
      },
    })
  }
} catch (error) {
  console.log(error)
}

// 扩展全局方法
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $bridge: Bridge
    //$sensors: typeof SensorsData.sensors
    $qt: typeof QT.qt
    $eventBus: Emitter<Record<EventType, unknown>>
    // $sentry: typeof SentryVue;
    AMap: typeof AMap
    [key: string]: any
  }
}

const app: App<Element> = createApp(Main)

const eventBus: Emitter<Record<EventType, unknown>> = mitt()
app.config.globalProperties.$eventBus = eventBus
app.config.globalProperties.$cookies = Cookies

app.use(Store)
app.use(GwmBridge)
//app.use(SensorsData)
app.use(Lazyload, {
  loading: defLoadingImg,
  error: defLoadingImg,
})
app.use(Router)
app.use(Filter)
app.use(Directive)
app.use(QT)
// Sentry(app, Router);

app.mount('#app')
